/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'eye': {
    width: 33,
    height: 20,
    viewBox: '0 0 33 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M32.337 8.98C32.027 8.602 25.105 0 16.297 0S.567 8.603.257 8.98c-.343.41-.343.992 0 1.438.31.378 7.232 8.98 16.04 8.98s15.73-8.636 16.04-8.978a1.239 1.239 0 000-1.44zm-16.04 7.163a6.436 6.436 0 01-6.444-6.444 6.436 6.436 0 016.444-6.443 6.437 6.437 0 016.444 6.443 6.437 6.437 0 01-6.444 6.444z" _fill="#243334"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M20.203 9.7a3.906 3.906 0 11-7.812 0 3.906 3.906 0 117.812 0z" _fill="#243334"/>'
  }
})
